import PropTypes from 'prop-types';

export const basemap = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.object
]);